import React, { useState } from 'react';
import { QuestionMarkCircleIcon, XMarkIcon } from '@heroicons/react/24/outline';

export default function HelpButton({ title, sections }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {/* Bouton Aide */}
      <button
        onClick={() => setIsOpen(true)}
        className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 transition-colors shadow-sm"
        title="Aide"
      >
        <QuestionMarkCircleIcon className="h-5 w-5 mr-2 text-honey-600" />
        Aide
      </button>

      {/* Modal */}
      {isOpen && (
        <div className="fixed inset-0 z-50 overflow-y-auto">
          <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
            {/* Overlay */}
            <div
              className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75"
              onClick={() => setIsOpen(false)}
            />

            {/* Modal panel */}
            <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-2xl sm:w-full">
              {/* Header */}
              <div className="bg-honey-50 px-6 py-4 border-b border-honey-100">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <div className="flex-shrink-0 w-10 h-10 bg-honey-100 rounded-full flex items-center justify-center">
                      <QuestionMarkCircleIcon className="h-6 w-6 text-honey-600" />
                    </div>
                    <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
                  </div>
                  <button
                    onClick={() => setIsOpen(false)}
                    className="text-gray-400 hover:text-gray-500 transition-colors"
                  >
                    <XMarkIcon className="h-6 w-6" />
                  </button>
                </div>
              </div>

              {/* Content */}
              <div className="px-6 py-6 max-h-[70vh] overflow-y-auto">
                <div className="space-y-6">
                  {sections.map((section, index) => (
                    <div key={index}>
                      <h4 className="text-base font-semibold text-gray-900 mb-3">
                        {section.title}
                      </h4>
                      <div className="space-y-2 text-sm text-gray-700">
                        {section.content.split('\n').map((line, lineIndex) => {
                          const trimmedLine = line.trim();
                          
                          if (!trimmedLine) {
                            return <div key={lineIndex} className="h-2" />;
                          }
                          
                          // Liste à puces avec •
                          if (trimmedLine.startsWith('•')) {
                            const content = trimmedLine.substring(1).trim();
                            return (
                              <div key={lineIndex} className="flex gap-2 ml-4">
                                <span className="text-honey-600 font-bold flex-shrink-0">•</span>
                                <span>
                                  {content.split('**').map((part, i) => 
                                    i % 2 === 0 ? part : <strong key={i} className="font-semibold text-gray-900">{part}</strong>
                                  )}
                                </span>
                              </div>
                            );
                          }
                          
                          // Liste avec tirets -
                          if (trimmedLine.startsWith('-')) {
                            const content = trimmedLine.substring(1).trim();
                            return (
                              <div key={lineIndex} className="flex gap-2 ml-8">
                                <span className="text-gray-500 flex-shrink-0">-</span>
                                <span className="text-gray-600 text-sm">
                                  {content.split('**').map((part, i) => 
                                    i % 2 === 0 ? part : <strong key={i} className="font-semibold">{part}</strong>
                                  )}
                                </span>
                              </div>
                            );
                          }
                          
                          // Titre avec **
                          if (trimmedLine.startsWith('**') && trimmedLine.endsWith('**')) {
                            const title = trimmedLine.replace(/\*\*/g, '');
                            return (
                              <h5 key={lineIndex} className="font-semibold text-gray-900 mt-3 mb-1">
                                {title}
                              </h5>
                            );
                          }
                          
                          // Paragraphe normal
                          return (
                            <p key={lineIndex} className="leading-relaxed">
                              {trimmedLine.split('**').map((part, i) => 
                                i % 2 === 0 ? part : <strong key={i} className="font-semibold text-gray-900">{part}</strong>
                              )}
                            </p>
                          );
                        })}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Footer */}
              <div className="bg-gray-50 px-6 py-4 border-t border-gray-200">
                <button
                  onClick={() => setIsOpen(false)}
                  className="w-full sm:w-auto px-6 py-2 bg-gray-900 text-white text-sm font-medium rounded-lg hover:bg-gray-800 transition-colors"
                >
                  Fermer
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
